import { useState } from 'react'
import { BlockComponentFactory } from '../BlockFactory'
import { ListBlockProps } from './block-props.types'
import Flex from 'antd/lib/flex'
import ChevronDown from '../../../assets/icons/chevron-down.svg?react'
import { LabelBlock } from './LabelBlock'
import { LABEL_BOLD_FONT_STYLE } from '../../constants'
import { toCSSSize } from './block-utils'

export const ListBlock = BlockComponentFactory.createBlockComponent<ListBlockProps>(props => {
    const {
        label,
        showCount = false,
        collapsible = false,
        value = [],
        visibility = 'visible',
        children,
        width,
        height,
    } = props

    const [isCollapsed, setIsCollapsed] = useState(false)

    const containerStyle: React.CSSProperties = {
        ...props.style,
        display: visibility === 'hidden' ? 'none' : 'flex',
        flexDirection: 'column',
        gap: '8px',
        padding: '12px',
        backgroundColor: '#ffffff',
        borderRadius: '4px',
        border: '1px solid #D8D8D8',
    } as React.CSSProperties

    const labelWrapperStyle: React.CSSProperties = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        gap: '8px',
        cursor: collapsible ? 'pointer' : 'default',
        userSelect: 'none',
    }

    const arrowStyle: React.CSSProperties = {
        transition: 'transform 0.2s ease',
        transform: isCollapsed ? 'rotate(0deg)' : 'rotate(180deg)',
        marginLeft: 'auto',
    }

    const handleToggle = () => {
        if (collapsible) {
            setIsCollapsed(!isCollapsed)
        }
    }

    const listContainerStyle: React.CSSProperties = {
        width: toCSSSize(width) ?? 'auto',
    }

    const contentStyle: React.CSSProperties = {
        height: toCSSSize(height) ?? 'auto',
        overflow: 'auto',
    }

    return (
        <Flex vertical gap="6px" style={listContainerStyle}>
            {showCount && (
                <Flex justify="flex-end" gap="4px">
                    <div>Count:</div>
                    <span>{value?.length ?? 0}</span>
                </Flex>
            )}
            <div style={containerStyle}>
                <Flex style={labelWrapperStyle} onClick={handleToggle}>
                    <LabelBlock label={label} labelStyle={LABEL_BOLD_FONT_STYLE} />
                    {collapsible && (
                        <span style={arrowStyle}>
                            <ChevronDown />
                        </span>
                    )}
                </Flex>
                {(!collapsible || !isCollapsed) && <div style={contentStyle}>{children}</div>}
            </div>
        </Flex>
    )
})
